import { useAuth } from "./useAuth";
import { useEffect, useState } from "react";
import { useGetUserByUserIdQuery } from "../../redux/features/usersManagement/usersManagementApi";
import { useDispatch } from "react-redux";
import { useVerifyTokenQuery } from "../../redux/features/auth/authApi";
import {
  getDecriptedTokenInfo,
  getLoginData,
} from "../../redux/features/auth/authSlice";

export const useTokenVerify = () => {
  const dispatch = useDispatch();
  const { auth } = useAuth();

  const {
    data: verifiedToken,
    isLoading: tokenLoading,
    isError: tokenError,
  } = useVerifyTokenQuery(auth.token, {
    skip: !auth.token,
  });

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (verifiedToken && !tokenLoading && !tokenError) {
      dispatch(getDecriptedTokenInfo(verifiedToken));
      setIsLoading(false);
    }
  }, [verifiedToken, tokenLoading, tokenError, dispatch]);

  const {
    data: userData,
    isError: userDataError,
    isLoading: userDataLoading,
  } = useGetUserByUserIdQuery(verifiedToken?.user_id, {
    skip: !verifiedToken?.user_id || verifiedToken?.expired,
  });

  useEffect(() => {
    if (!userDataError && userData && !verifiedToken.expired) {
      dispatch(getLoginData({ ...auth, userData: userData }));
    }
  }, [userData, userDataError, verifiedToken, dispatch]);

  return { ...verifiedToken, isLoading };
};
